import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import AuthPage from "@/pages/AuthPage";
import JobsPage from "@/pages/JobsPage";
import JobDetailPage from "@/pages/JobDetailPage";
import CommunityPage from "@/pages/CommunityPage";
import ProfilePage from "@/pages/ProfilePage";
import EventsPage from "@/pages/EventsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import MessagesPage from "@/pages/MessagesPage";
import AdminPage from "@/pages/AdminPage";
import EmployerDashboard from "@/pages/EmployerDashboard";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CommunityGuidelinesPage from "@/pages/CommunityGuidelinesPage";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={!user ? <AuthPage setUser={setUser} /> : <Navigate to="/jobs" />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/guidelines" element={<CommunityGuidelinesPage />} />
          <Route element={<Layout user={user} setUser={setUser} />}>
            <Route path="/" element={<Navigate to="/jobs" />} />
            <Route path="/jobs" element={user ? <JobsPage user={user} /> : <Navigate to="/auth" />} />
            <Route path="/jobs/:id" element={user ? <JobDetailPage /> : <Navigate to="/auth" />} />
            <Route path="/community" element={user ? <CommunityPage user={user} /> : <Navigate to="/auth" />} />
            <Route path="/profile/:id" element={user ? <ProfilePage user={user} /> : <Navigate to="/auth" />} />
            <Route path="/events" element={user ? <EventsPage /> : <Navigate to="/auth" />} />
            <Route path="/events/:id" element={user ? <EventDetailPage /> : <Navigate to="/auth" />} />
            <Route path="/messages" element={user ? <MessagesPage user={user} /> : <Navigate to="/auth" />} />
            <Route path="/employer" element={user?.role === "employer" ? <EmployerDashboard user={user} /> : <Navigate to="/jobs" />} />
            <Route path="/admin" element={user?.role === "admin" ? <AdminPage /> : <Navigate to="/jobs" />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;